/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { IObrienAbout23ViewProps } from './obrien-about23';

export default (props: IObrienAbout23ViewProps) => {
    const { 
        obAboutBackground, 
        obAboutLogo, 
        obAboutContent,
        links1
    } = props;
    return (
        <>
        <section className="AboutBanners">
            <div className="App">
                <section id="about-obrien" className="ob-about">
                    
                    <div className="gradient1"></div>
                    {obAboutBackground}
                    <div className="gradient2"></div>
                    <div className="gradient3"></div>
                    
                    <div className="text-container inside-xl">
                        <div>
                            <div>
                                <div className="inside-xxs align-center">
                                    <figure><img src={obAboutLogo} alt="O'Brien Logo"/></figure>
                                </div>
                                <div className="inside-md white-trans" dangerouslySetInnerHTML={{ __html: obAboutContent }}></div>
                                {links1}
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </section>

       
        </>
    );
};
